// filepath: /opt/flexihub/frontend/src/services/livekit.ts
import { Room, RoomEvent, createLocalTracks } from 'livekit-client';
import { API_CONFIG } from '../config/api.config';

// Interface pour la réponse du token
interface TokenResponse {
  token: string;
  url: string;
}

export async function getRtcToken(params: { room: string; identity: string; name?: string }): Promise<TokenResponse> {
  const { room, identity, name } = params;
  
  // Récupération du token d'auth (JWT) pour sécuriser l'appel à votre API
  const authToken = localStorage.getItem('token') || localStorage.getItem('accessToken');

  const resp = await fetch(`${API_CONFIG.baseURL}/livekit/token`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      ...(authToken ? { 'Authorization': `Bearer ${authToken}` } : {})
    },
    body: JSON.stringify({ roomName: room, identity, name }),
  });

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.message || 'Échec récupération token LiveKit');
  }
  
  return await resp.json();
}

export async function connectLiveKit(roomName: string, identity: string) {
  const resp = await fetch(`${API_CONFIG.baseURL}/livekit/token`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ roomName, identity }),
  });
  if (!resp.ok) throw new Error('Échec token LiveKit');
  const { token } = await resp.json();

  const lkUrl = process.env.REACT_APP_LIVEKIT_HOST || 'wss://livekit.flexihub.io';
  const room = new Room();
  await room.connect(lkUrl, token, { autoSubscribe: true });

  const tracks = await createLocalTracks({ audio: true, video: true });
  for (const t of tracks) await room.localParticipant.publishTrack(t);

  room.on(RoomEvent.ParticipantConnected, (p) => console.log('Participant:', p.identity));
  room.on(RoomEvent.TrackSubscribed, (track, pub, p) => console.log('Track:', p.identity, pub.trackName));
  return room;
}